import { Guarded } from ":setup/qrouter";
import routes from "./routes";
import authRoutes from "../auth/routes";
import { Route } from "@solidjs/router";

export default function Landing() {
	const baseRoute = routes.BASE;
	return (
		<Guarded
			setup={{
				baseRoute,
			}}
			components={{
				layout: (props) => {
					return <>{props.children}</>;
				},
				pageNotFound: () => (
					<div>this is landing page error, this page doesn't exist</div>
				),
			}}
			events={{
				onRouteFirstLoad(trigger, props) {
					trigger.navigate({ base: authRoutes.BASE });
				},
			}}
		/>
	);
}
